import { useEffect, useMemo } from 'react';
import { useRegistersListQuery } from '@/modules/common/queries/registers.ts';

export const useFetchAllRegisters = () => {
  const { hasNextPage, fetchNextPage, data, isLoading, isFetchingNextPage } = useRegistersListQuery(
    { page: 1, page_size: 15, filter_by_name: '' },
  );

  const adaptedRegisters = useMemo(
    () => (data?.pages || []).flatMap(({ data }) => data),
    [data?.pages],
  );

  useEffect(() => {
    if (hasNextPage && !isLoading && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage, isLoading]);

  return {
    registers: adaptedRegisters,
    isFetchingNextPage,
    isLoading,
  };
};
